<template>
  <v-application>
    <v-toolbar class="mb-2 px-0" flat>
      <v-btn icon v-on:click="back">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-toolbar-title>{{title}}</v-toolbar-title>
      <v-spacer />
      <slot name="actions" />
    </v-toolbar>
    <slot />
  </v-application>
</template>
<script>
export default {
  name: 'v-application-view',
  props: {
    title: String
  },
  methods: {
    back(){
      if(this.$route.query['back']){
        this.$router.push({name: this.$route.query['back']})
      }
      else{
        this.$router.push({path: '/'})
      }
    }
  }
}
</script>
